import { z } from 'zod';
import { paginationQuerySchema, queryBoolean } from './common.js';
export const createAdminSchema = z.object({
    fullName: z.string().trim().min(2, 'Name is required').max(120),
    email: z.string().trim().toLowerCase().email('A valid email is required').max(255),
});
export const listAllMailboxesQuerySchema = paginationQuerySchema.extend({
    search: z.string().trim().max(200).optional(),
    /**
     * Decrypt and return the stored app passwords.
     *
     * Off by default and gated to SUPER_ADMIN. Every reveal is written to the
     * audit log, because this is the one operation in the system that turns
     * encrypted-at-rest credentials back into plaintext.
     *
     * Must use `queryBoolean` rather than `z.coerce.boolean()` — the latter reads
     * the string "false" as true, which meant credentials were decrypted and
     * returned on every request whether or not they had been asked for.
     */
    revealSecrets: queryBoolean.default(false),
});
//# sourceMappingURL=superAdmin.js.map